/* eslint no-use-before-define: 0 */

import ErrorService from "../services/error.service";
import CustomInfobox from "./custom-infobox.component";

export default class StaticMapComponent {
    /**
     *
     * @param {Object} jqNode - Jquery node
     */
    constructor(jqNode) {
        this.jqNode = jqNode;
        this.args = null;
        this.errorService = new ErrorService(jqNode);
        this.zoom = null;
        this.gmMap = null;

        this.initialize();
    }

    /**
    * @private
    */
    initialize() {
        const scope = this;

        parseArgsFromHTML();
        resolveZoom();
        initGmMap();
        initCustomInfobox();

        function initCustomInfobox() {
            const contentDiv = createContentDiv();
            const point = new window.google.maps.LatLng(scope.args.lat, scope.args.lng);
            // eslint-disable-next-line no-unused-vars
            const infobox = new CustomInfobox(point, contentDiv, scope.gmMap);

            /**
             * @returns {Object} - DOM node
             */
            function createContentDiv() {
                const contentDivJq = scope.jqNode.parent().find(".static-map-js-component-content");
                contentDivJq.html(scope.args.name);
                return contentDivJq.get(0);
            }
        }

        function initGmMap() {
            scope.gmMap = new window.google.maps.Map(scope.jqNode.get(0),
                {
                    zoom: scope.zoom,
                    center: { lat: scope.args.lat, lng: scope.args.lng },
                    draggable: false,
                    keyboardShortcuts: false,
                });
        }

        function resolveZoom() {
            if (scope.args.globalZoom) {
                scope.zoom = scope.args.globalZoom;
            }
            if (scope.args.zoom) {
                scope.zoom = scope.args.zoom;
            }
        }

        function parseArgsFromHTML() {
            scope.args = {
                lat: scope.jqNode.data("lat"),
                lng: scope.jqNode.data("long"),
                zoom: scope.jqNode.data("zoom"),
                name: scope.jqNode.data("name"),
                globalZoom: scope.jqNode.data("global-zoom"),
            };

            if (scope.args.lat) {
                scope.args.lat = parseFloat(scope.args.lat.toString().replace(",", "."));
            }

            if (scope.args.lng) {
                scope.args.lng = parseFloat(scope.args.lng.toString().replace(",", "."));
            }

            if (scope.args.zoom) {
                scope.args.zoom = parseInt(scope.args.zoom, 10);
            }

            if (scope.args.globalZoom) {
                scope.args.globalZoom = parseInt(scope.args.globalZoom, 10);
            }
        }
    }
}
